import { API_BASE_URL } from "src/config/apiBase";
import { decryptToken } from "../../../Components/utils/getToken";

const BASE = `${API_BASE_URL}/api/saas/v1`;

async function request(path, options = {}) {
  const headers = { "Content-Type": "application/json", ...(options.headers || {}) };
  const token = decryptToken("accessToken");
  if (token) headers.Authorization = `Bearer ${token}`;

  const res = await fetch(`${BASE}${path}`, {
    ...options,
    headers,
    body: options.body ? JSON.stringify(options.body) : undefined,
  });

  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    const err = new Error(data.message || "Request failed");
    err.status = res.status;
    err.data = data;
    throw err;
  }
  return data;
}

export const saasApi = {
  getPublicPlans: () => request("/plans/public"),
  register: (payload) => request("/register", { method: "POST", body: payload }),
  verifyEmail: (payload) => request("/register/verify-email", { method: "POST", body: payload }),
  resendVerification: (payload) => request("/register/resend-verification", { method: "POST", body: payload }),
  resendVerificationEmail: (email) =>
    request("/register/resend-verification", { method: "POST", body: { email } }),
  getSubscription: () => request("/subscriptions/current"),
  createOrder: (payload) => request("/payments/create-order", { method: "POST", body: payload }),
  verifyPayment: (payload) => request("/payments/verify", { method: "POST", body: payload }),
  getPaymentHistory: () => request("/payments/history"),
  getCompany: () => request("/company"),
  adminCompanies: (params = "") => request(`/admin/companies${params}`),
  adminAnalyticsOverview: () => request("/admin/analytics/overview"),
  adminAnalyticsTrials: () => request("/admin/analytics/trials"),
  adminPayments: (params = "") => request(`/admin/payments${params}`),
  adminPlans: () => request("/plans/admin/all"),
  createPlan: (payload) => request("/plans/admin", { method: "POST", body: payload }),
  updatePlan: (id, payload) => request(`/plans/admin/${id}`, { method: "PUT", body: payload }),
  deactivatePlan: (id) => request(`/plans/admin/${id}/deactivate`, { method: "PATCH" }),
  suspendCompany: (id) => request(`/admin/companies/${id}/suspend`, { method: "PATCH" }),
  activateCompany: (id) => request(`/admin/companies/${id}/activate`, { method: "PATCH" }),
};

export default saasApi;
